import { useState } from 'react';
import ApplicationAppService from '../../../application/platform/application-app-service';
import { IAuthenticationData } from '../../../model/authentication-data';
import { parseIdFilter } from '../../../utils/filter-options';

const STORAGE_KEY = 'ser_client_id';
// Tipo de autenticação do usuário vinculado a um cliente (a "company" da sessão é o próprio cliente)
const CLIENT_USER_TYPE = 1;

export interface SessionClient {
    isClientUser: boolean;
    clientId?: number;
}

function readStoredClient(): number | undefined {
    try {
        return parseIdFilter(sessionStorage.getItem(STORAGE_KEY) ?? undefined);
    } catch {
        return undefined;
    }
}

function storeClient(clientId: number) {
    try {
        sessionStorage.setItem(STORAGE_KEY, String(clientId));
    } catch {
        // Sem sessionStorage o cliente só não é lembrado entre as telas
    }
}

// Usuário de cliente usa o cliente da sessão; usuário da empresa escolhe (e a escolha é lembrada na aba)
export function resolveSessionClient(auth: IAuthenticationData | undefined, storedClientId?: number): SessionClient {
    if (auth?.type === CLIENT_USER_TYPE && auth.company?.id) {
        return { isClientUser: true, clientId: auth.company.id };
    }
    return { isClientUser: false, clientId: storedClientId };
}

export function useSerClient() {
    const [session, setSession] = useState<SessionClient>(() =>
        resolveSessionClient(ApplicationAppService.getAuthenticationData(), readStoredClient()));

    // O DefaultSelectClient notifica valores vazios ao montar; só uma entidade escolhida troca o cliente
    function setClientId(value: unknown) {
        if (session.isClientUser) return;
        const clientId = parseIdFilter(value);
        if (!clientId || clientId === session.clientId) return;
        storeClient(clientId);
        setSession({ isClientUser: false, clientId });
    }

    return { ...session, setClientId };
}
